// app entry
import '@@/core/polyfill'


import('./bootstrap');

// generated at 2026/3/3 14:42:05 by sui v3.1.133